import React from "react";
import { PassosEnumerados, SectionContent, Text } from "../../../../components";
import primeiroPassoImg from "../../../../assets/images/catalogo/ilustracao-mulher-mostrando-primeiro-passo.svg";
import segundoPassoImg from "../../../../assets/images/catalogo/ilustracao-mulher-com-livro.svg";
import terceiroPassoImg from "../../../../assets/images/catalogo/ilustracao-mulher-apaixonada.svg";

const SamplePassosEnumerados = () => {
  return (
    <SectionContent>
      <PassosEnumerados>
        <PassosEnumerados.Passo
          imgSrc={primeiroPassoImg}
          imgAlt="Imagem Primeiro Passo"
        >
          <Text textSize="sm">Este é o conteúdo do primeiro passo</Text>
        </PassosEnumerados.Passo>
        <PassosEnumerados.Passo
          imgSrc={segundoPassoImg}
          imgAlt="Imagem Segundo Passo"
        >
          <Text textSize="sm">Este é o conteúdo do segundo passo</Text>
        </PassosEnumerados.Passo>
        <PassosEnumerados.Passo
          imgSrc={terceiroPassoImg}
          imgAlt="Imagem Terceiro Passo"
        >
          <Text textSize="sm">Este é o conteúdo do Terceiro passo</Text>
        </PassosEnumerados.Passo>
      </PassosEnumerados>
    </SectionContent>
  );
};

export default SamplePassosEnumerados;
